import * as Styled from './SchedulesEmptyLabel.styled'

export function SchedulesEmptyLabel() {
  return (
    <Styled.EmptyContainer>
      <Styled.NoGamesTitle>No Schedules Found</Styled.NoGamesTitle>
    </Styled.EmptyContainer>
  )
}
